/** Design System — Animation tokens. Subtle enterprise motion only. */
export const duration = {
  instant: '0ms',
  fast: '120ms',
  normal: '200ms',
  slow: '320ms',
} as const;

export const easing = {
  standard: 'cubic-bezier(0.2, 0, 0, 1)',
  accelerate: 'cubic-bezier(0.3, 0, 1, 1)',
  decelerate: 'cubic-bezier(0, 0, 0.2, 1)',
} as const;

export const animation = { duration, easing } as const;
export type Animation = typeof animation;
